import { useSelector } from '@/libs/state'
import { makeToggleSearch } from '../application/toggle-search'
import { search$, searchAdapter } from '../store'

const toggle = makeToggleSearch(searchAdapter)

const useSearch = () => {
	const isOpen = useSelector(() => search$.isOpen.get())
	return { isOpen, toggle }
}

export { useSearch }
